import { getAuthenticatedRequestInit } from '../connection/utils';

export const CreateIOSNotification = (token: string, emails: string, profiles: string, message: string) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/ios-notification/create`, {
		method: 'POST',
		body: JSON.stringify({
			emails: emails,
			profiles: profiles,
			message: message,
		}),
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (!result.ok) {
			console.error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/ios-notification/create status ${result.status}`);
		}
	});
};
